export default __webpack_public_path__ + "static/media/OG_logo_frame.4de48314.svg";